<template>
    <div class="inline-block">
        <div v-if="formOpen === false">
            <template v-if="isEdit">
                <button
                    type="button"
                    @click="formOpen = !formOpen"
                    class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    <svg viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4">
                        <path
                            d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                        ></path>
                    </svg>
                </button>
            </template>
            <template v-else>
                <AppButton element="button" type="button" @click="formOpen = !formOpen">
                    <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>

                    {{ $tc('messages.evaluation_criteria', 1) }}
                </AppButton>
            </template>
        </div>
        <template v-else>
            <Modal :show="formOpen" @close="formOpen = false">
                <form :action="endpoint.url" method="post" @submit.prevent="submit">
                    <div class="md:grid md:grid-cols-12 md:gap-6">
                        <div class="sm:col-span-8">
                            <div class="mt-1">
                                <FormLabel :value="$t('messages.name')" for="name" />
                                <FormInput
                                    required
                                    id="name"
                                    v-model="form.name"
                                    name="name"
                                    type="text"
                                    maxlength="180"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.name" class="mt-2" />
                            </div>
                        </div>

                        <div class="sm:col-span-4">
                            <div class="mt-1">
                                <FormLabel :value="$tc('messages.max_score', 1)" for="max_score" />
                                <FormInput
                                    required
                                    id="max_score"
                                    v-model="form.max_score"
                                    name="max_score"
                                    type="number"
                                    step="1"
                                    max="200"
                                    class="mt-1 w-full"
                                />
                                <FormError :value="form.errors.max_score" class="mt-2" />
                            </div>
                        </div>
                    </div>

                    <div class="flex space-x-2 items-center mt-3">
                        <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                            {{ $t('messages.save') }}
                            <span v-if="form.processing" class="ml-1 btn-spinner" />
                        </AppButton>
                        <AppButton element="button" type="button" @click="cancel()">
                            {{ $t('messages.cancel') }}
                        </AppButton>
                    </div>
                </form>
            </Modal>
        </template>
    </div>
</template>

<script>
import FormError from '@/components/Forms/FormError.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import AppButton from '@/components/AppButton.vue';
import Modal from '@/components/Modal.vue';

export default {
    name: 'SubactivityEditForm',
    components: {
        FormLabel,
        FormInput,
        FormError,
        AppButton,
        Modal,
    },
    props: {
        endpoint: {
            type: Object,
            required: true,
        },
        isEdit: {
            type: Boolean,
            default: false,
        },
        subactivity: {
            type: Object,
            required: false,
            default: () => ({
                name: '',
                max_score: 10,
            }),
        },
    },
    data() {
        return {
            formOpen: false,
            form: this.$inertia.form({
                name: this.subactivity.name,
                max_score: this.subactivity.max_score,
            }),
        };
    },
    methods: {
        cancel() {
            this.formOpen = false;
            this.form.reset('name', 'max_score');
            this.form.clearErrors();
        },
        submit() {
            this.form.submit(this.endpoint.method, this.endpoint.url, {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.reset('name', 'max_score');
                    this.formOpen = false;
                },
            });
        },
    },
};
</script>
